import { atoms } from '@zapier/marketing-ui';

type Props = {
  email: string;
};

export function EmailMessage({ email }: Props) {
  return (
    <p className={atoms.body}>
      You&apos;re signing up as{' '}
      <span className={`${atoms.fontSemibold} fs-exclude`}>{email}</span>.
    </p>
  );
}
